(() => {
 'use strict';
 if(window.OTSPhotoCart)return;
 const route=p=>(window.Shopify?.routes?.root||'/')+p;
 let busy=false,pass=false;
 function settings(doc=document){
  const node=doc.querySelector('[data-photo-cart-config]');
  if(!node)throw new Error('Photo checkout validation is not configured. Please contact us.');
  return JSON.parse(node.textContent);
 }
 function notice(error){
  let dialog=document.querySelector('[data-photo-cart-error]');
  if(!dialog){
   dialog=document.createElement('dialog');dialog.dataset.photoCartError='';
   dialog.style.cssText='max-width:480px;width:calc(100% - 40px);padding:24px;border:1px solid #344c3b;border-radius:8px;background:#fbfbf7;color:#23382d';
   const heading=document.createElement('h2');heading.textContent='Please check your photo';
   const message=document.createElement('p');message.dataset.message='';
   const list=document.createElement('div');list.dataset.links='';
   const close=document.createElement('button');close.type='button';close.textContent='Back to cart';close.onclick=()=>dialog.close();
   close.style.cssText='padding:12px 20px;min-height:44px;margin-top:16px';
   dialog.append(heading,message,list,close);document.body.append(dialog);
  }
  dialog.querySelector('[data-message]').textContent=error.message;
  const list=dialog.querySelector('[data-links]');list.replaceChildren();
  for(const item of error.items||[]){
   const link=document.createElement('a');link.href=route('products/'+encodeURIComponent(item.handle))+(settings().productView?'?view='+encodeURIComponent(settings().productView):'');link.textContent='Choose a photo for '+item.product_title;link.style.display='block';list.append(link);
  }
  dialog.showModal();
 }
 async function check(){
  const config=settings();
  const [cartResponse,pageResponse]=await Promise.all([
   fetch(route('cart.js'),{cache:'no-store'}),fetch(route('cart'),{cache:'no-store',headers:{Accept:'text/html'}})
  ]);
  if(!cartResponse.ok||!pageResponse.ok)throw new Error('Could not check your cart. Please try again.');
  const cart=await cartResponse.json(),page=new DOMParser().parseFromString(await pageResponse.text(),'text/html');
  const fresh=settings(page);
  const required=new Set(fresh.productIds.map(String));
  const items=cart.items.filter(item=>required.has(String(item.product_id))||item.properties?._ots_photo_job);
  if(!items.length)return;
  const response=await fetch(config.api.replace(/\/$/,'')+'/api/photo-print/cart/validate',{
   method:'POST',headers:{Accept:'application/json','content-type':'application/json'},credentials:'omit',
   body:JSON.stringify({shop:config.shop,items:items.map(({key,product_id,variant_id,properties})=>({key,product_id,variant_id,properties}))})
  });
  const data=await response.json();
  if(!response.ok)throw new Error(data.error||'Could not check your saved photo. Please retry.');
  if(!data.ok){
   const error=new Error(data.issues.map(issue=>issue.message).join('\n'));
   error.items=cart.items.filter(item=>data.issues.some(issue=>issue.key===item.key));throw error;
  }
  const latest=await fetch(route('cart.js'),{cache:'no-store'}).then(r=>r.json());
  if(JSON.stringify(cart.items.map(i=>[i.key,i.quantity]))!==JSON.stringify(latest.items.map(i=>[i.key,i.quantity])))throw new Error('Your cart changed. Please check it and continue again.');
 }
 async function proceed(event,callback){
  if(pass){pass=false;return;}
  event.preventDefault();event.stopImmediatePropagation();
  if(busy)return;busy=true;
  try{await check();callback();}catch(error){notice(error);}finally{busy=false;}
 }
 document.addEventListener('submit',event=>{
  const form=event.target;
  if(form.matches('form[action*="/cart"]')&&!form.matches('[action*="/cart/add"]')&&(event.submitter?.name==='checkout'||form.querySelector('[name="checkout"]')&&!event.submitter)){
   proceed(event,()=>{pass=true;form.requestSubmit(event.submitter||undefined);});
  }
 },true);
 document.addEventListener('click',event=>{
  const link=event.target.closest('a[href]');
  if(link&&/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout(?:[/?#]|$)/i.test(new URL(link.href).pathname)&&new URL(link.href).origin===location.origin)
   proceed(event,()=>location.assign(link.href));
 },true);
 window.OTSPhotoCart={check};
 // Hide opaque accelerated checkout controls only while a configured photo item is present.
 async function refresh(){
  try{
   const page=new DOMParser().parseFromString(await fetch(route('cart'),{cache:'no-store'}).then(r=>r.text()),'text/html');
   document.documentElement.classList.toggle('ots-photo-cart-pending',settings(page).productIds.length>0);
  }catch{/* Checkout handler shows an actionable error if validation cannot be performed. */}
 }
 if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,refresh);
})();